import { Component, DestroyRef, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  fromEvent,
  map,
  merge,
  of,
  shareReplay,
  filter,
  switchMap,
  timer,
} from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '../../../../../environments/environment.test';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-internet-connection',
  templateUrl: './internet-connection.component.html',
  styleUrls: ['./internet-connection.component.scss'],
  standalone: false,
})
export class InternetConnectionComponent {
  private readonly destroyRef = inject(DestroyRef);

  readonly online$ = merge(
    of(navigator.onLine),
    fromEvent(window, 'online').pipe(map(() => true)),
    fromEvent(window, 'offline').pipe(map(() => false)),
  ).pipe(shareReplay({ bufferSize: 1, refCount: true }));

  constructor(
    private readonly router: Router,
    private readonly httpClient: HttpClient,
  ) {
    this.online$
      .pipe(
        filter(online => !online),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.router.navigate(['/']);
      });

    timer(0, 30000)
      .pipe(
        switchMap(() => this.online$),
        filter(online => online),
        switchMap(() =>
          this.httpClient.get<boolean>(environment.healthCheckUrl),
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({
        next: healthy => {
          if (!healthy) {
            this.router.navigate(['/']);
          }
        },
        error: () => {
          this.router.navigate(['/']);
        },
      });
  }
}
